import { tenantActionTypes } from '@Actions/tenantActions';

const TenantReducer = (state = { }, action) => {
  switch (action.type) {
  case tenantActionTypes.GET_TENANTS.LOADING: {
    const { getTenantsLoading } = action;
    return {
      ...state,
      getTenantsLoading,
    };
  }
  case tenantActionTypes.GET_TENANTS.SUCCESS: {
    const { tenants } = action;
    return {
      ...state,
      tenants,
    };
  }
  case tenantActionTypes.GET_TENANT_ANALYTICS.LOADING: {
    const { getTenantsAnalyticsLoading } = action;
    return {
      ...state,
      getTenantsAnalyticsLoading,
    };
  }
  case tenantActionTypes.GET_TENANT_ANALYTICS.SUCCESS: {
    const { tenantsAnalytics } = action;
    return {
      ...state,
      tenantsAnalytics,
    };
  }
  case tenantActionTypes.GET_TENANT_BY_ID.SUCCESS: {
    const { selectedTenant } = action;
    return {
      ...state,
      selectedTenant,
    };
  }
  case tenantActionTypes.UPDATE_TENANT.LOADING: {
    const { updateTenantLoading } = action;
    return {
      ...state,
      updateTenantLoading,
    };
  }
  case tenantActionTypes.CREATE_TENANT.LOADING: {
    const { createTenantLoading } = action;
    return {
      ...state,
      createTenantLoading,
    };
  }
  case tenantActionTypes.CREATE_TENANT.SUCCESS: {
    const { createdTenant } = action;
    return {
      ...state,
      createdTenant,
    };
  }
  case tenantActionTypes.DELETE_TENANT.LOADING: {
    const { deleteTenantLoading } = action;
    return {
      ...state,
      deleteTenantLoading,
    };
  }
  case tenantActionTypes.CREATE_USER.LOADING: {
    const { createUserLoading } = action;
    return {
      ...state,
      createUserLoading,
    };
  }
  case tenantActionTypes.CREATE_USER.SUCCESS: {
    const { createdUser } = action;
    return {
      ...state,
      createdUser,
    };
  }
  case tenantActionTypes.GET_USERS.LOADING: {
    const { getUsersLoading } = action;
    return {
      ...state,
      getUsersLoading,
    };
  }
  case tenantActionTypes.GET_USERS.SUCCESS: {
    const { users } = action;
    return {
      ...state,
      users,
    };
  }
  case tenantActionTypes.DELETE_USER.LOADING: {
    const { deleteUserLoading } = action;
    return {
      ...state,
      deleteUserLoading,
    };
  }
  case tenantActionTypes.GET_TENANTS_CONFIGURATION.LOADING: {
    const { getTenantsConfigurationLoading } = action;
    return {
      ...state,
      getTenantsConfigurationLoading,
    };
  }
  case tenantActionTypes.GET_TENANTS_CONFIGURATION.SUCCESS: {
    const { tenantsConfiguration } = action;
    return {
      ...state,
      tenantsConfiguration,
    };
  }
  case tenantActionTypes.UPDATE_TENANT_CONFIGURATION.LOADING: {
    const { updateTenantConfigurationLoading } = action;
    return {
      ...state,
      updateTenantConfigurationLoading,
    };
  }
  case tenantActionTypes.GET_ORG_USERS.LOADING: {
    const { getOrgUsersLoading } = action;
    return {
      ...state,
      getOrgUsersLoading,
    };
  }
  case tenantActionTypes.GET_ORG_USERS.SUCCESS: {
    const { orgUsers } = action;
    return {
      ...state,
      orgUsers,
    };
  }
  default: {
    return state;
  }
  }
};

export default TenantReducer;
